export enum UnrealisedAssetFXGainOrLossType {
  UnrealisedAssetFXGain = 'UnrealisedAssetFXGain',
  UnrealisedAssetFXLoss = 'UnrealisedAssetFXLoss',
  UnrealisedAssetFXUnwindGain = 'UnrealisedAssetFXUnwindGain',
  UnrealisedAssetFXUnwindLoss = 'UnrealisedAssetFXUnwindLoss',
}
